var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
  callback: _vm.visibilityChanged,
  throttle: 10,
  once: true,
}),expression:"{\n  callback: visibilityChanged,\n  throttle: 10,\n  once: true,\n}"}]},[(!_vm.rendered && !_vm.error)?_c('div',{style:({height: `${_vm.width * _vm.ratio}px`})},[_c('v-progress-linear',{attrs:{"indeterminate":""}})],1):_vm._e(),(_vm.error)?_c('div',[_vm._v("Error "+_vm._s(_vm.error))]):_vm._e(),(_vm.page && !_vm.error)?[_c('PDFPage',{attrs:{"page":_vm.page,"width":_vm.width,"ratio":_vm.ratio},on:{"rendered":_vm.onRendered,"failure":_vm.onFailure}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }